/* global dataLayer */

export default () => {
    function trackCheckoutStep(step) {
        const data = {
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: { step: step },
                    products: window.cartContents,
                },
            },
        }

        dataLayer.push(data)
    }

    function trackPurchase() {
        const data = {
            ecommerce: {
                purchase: window.orderDetails,
            },
        }

        dataLayer.push(data)
    }

    if (document.querySelector('.store-checkout-form-group-summary')) {
        trackCheckoutStep('Billing details')
    }

    if (document.querySelector('.store-order-complete-page')) {
        trackPurchase()
    }
}
